module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-waterheating@2x.png?fc315c72de1543241485b6d0fb7a406a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-waterheating@2x.png
// module id = 1053
// module chunks = 1